"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "milestones_cont" };
const _hoisted_2 = { class: "milestones" };
const _hoisted_3 = { class: "ma-title" };
const _hoisted_4 = ["title"];
const _hoisted_5 = { class: "ma-player-cube" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "milestone-award-price" };
const _hoisted_8 = ["title"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Milestone = (0, vue_1.resolveComponent)("Milestone");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    const _directive_trim_whitespace = (0, vue_1.resolveDirective)("trim-whitespace");
    return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", _hoisted_3, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                    class: "ma-clickable",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = (0, vue_1.withModifiers)(($event) => (_ctx.toggleList()), ["prevent"]))
                }, [...(_cache[2] || (_cache[2] = [
                        (0, vue_1.createTextVNode)("Milestones", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.milestones.filter((m) => m.playerName), (milestone) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                        key: milestone.name,
                        class: "milestone-award-inline paid",
                        title: milestone.playerName
                    }, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(milestone.name), 1)
                        ])), [
                            [_directive_i18n]
                        ]),
                        (0, vue_1.createElementVNode)("span", _hoisted_5, [
                            (0, vue_1.createElementVNode)("i", {
                                class: (0, vue_1.normalizeClass)('board-cube board-cube--' + milestone.color)
                            }, null, 2)
                        ])
                    ], 8, _hoisted_4));
                }), 128)),
                (_ctx.isLearnerModeOn())
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_6, [
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getAvailableMilestoneSpots(), (spotPrice, index) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                                key: index,
                                class: "milestone-award-inline unpaid"
                            }, [
                                (0, vue_1.createElementVNode)("div", _hoisted_7, (0, vue_1.toDisplayString)(spotPrice), 1)
                            ]));
                        }), 128))
                    ]))
                    : (0, vue_1.createCommentVNode)("", true)
            ]),
            (0, vue_1.createElementVNode)("span", {
                onClick: _cache[1] || (_cache[1] =
                    (...args) => (_ctx.toggleDescription && _ctx.toggleDescription(...args))),
                title: _ctx.$t('press to show or hide the description'),
                "data-test": "toggle-description"
            }, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("div", null, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.milestones, (milestone) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_Milestone, {
                            key: milestone.name,
                            milestone: milestone,
                            showScores: _ctx.showScores,
                            showDescription: _ctx.showDescription
                        }, null, 8, ["milestone", "showScores", "showDescription"]));
                    }), 128))
                ], 512), [
                    [vue_1.vShow, _ctx.showMilestoneDetails]
                ])
            ], 8, _hoisted_8)
        ])
    ])), [
        [_directive_trim_whitespace]
    ]);
}
